import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components/macro";

export function BenefitCard({ classes, isActive = false, variant = "", text = "", isQuadrant = false, baseUnit = 1, height = undefined, background = undefined }) {
	const { t } = useTranslation();
	const getIcon = (variant) => {
		switch (variant) {
			case "quickWin":
				return "🎉";
			case "niceToHave":
				return "😉";
			case "complexProj":
				return "🐘️️";
			default:
				return "🚧️️";
		}
	};
	return (
		<Card className={classes} isActive={isActive} variant={variant} isQuadrant={isQuadrant} baseUnit={baseUnit} height={height} background={background}>
			<span style={{ opacity: isActive ? 1 : 0.5, fontFamily: "Font Name, sans-serif", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.1em" }}>{getIcon(variant)}</span>
			<CardText>{t(text)}</CardText>
		</Card>
	);
}

const Card = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	width: fit-content;
	height: 30px;
	border-radius: 6px;
	background: #f5f5f5;
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
	color: #262626;

	${(props) =>
		!props.isActive &&
		css`
			color: transparent;
			text-shadow: 0 0 0 grey;
		`}

	${(props) =>
		props.isActive &&
		props.variant === "quickWin" &&
		css`
			background: #dbeafe;
			${(props) =>
				props.isQuadrant &&
				css`
					transform: rotate(-90deg);
					position: absolute;
					left: calc(-1.55 * ${(props) => props.baseUnit}px);
					top: calc(2.7 * ${(props) => props.baseUnit}px);
				`}
		`}
	${(props) =>
		props.isActive &&
		props.variant === "niceToHave" &&
		css`
			background: #ede9fe;
			${(props) =>
				props.isQuadrant &&
				css`
					transform: rotate(-90deg);
					position: absolute;
					left: calc(-1.75 * ${(props) => props.baseUnit}px);
					bottom: calc(2.2 * ${(props) => props.baseUnit}px);
				`}
		`}
    ${(props) =>
		props.isActive &&
		props.variant === "complexProj" &&
		css`
			background: #ffedd5;
			${(props) =>
				props.isQuadrant &&
				css`
					transform: rotate(-90deg);
					position: absolute;
					right: calc(-1.92 * ${(props) => props.baseUnit}px);
					top: calc(2.8 * ${(props) => props.baseUnit}px);
				`}
		`}
    ${(props) =>
		props.isActive &&
		props.variant === "toAvoid" &&
		css`
			background: #fee2e2;

			${(props) =>
				props.isQuadrant &&
				css`
					transform: rotate(-90deg);
					position: absolute;
					right: calc(-1.52 * ${(props) => props.baseUnit}px);
					bottom: calc(2.3 * ${(props) => props.baseUnit}px);
				`}
		`}
    ${(props) =>
		props.height &&
		css`
			height: ${props.height}px;
		`}
    ${(props) =>
		props.background &&
		css`
			background: ${props.background};
		`}
`;

const CardText = styled.div`
	display: flex;
	white-space: nowrap;
`;
